import { keyframes } from '@emotion/core'
import styled from '@themes/theme'

export const activityScoreAni = keyframes`
  0% {
    bottom: 60px;
    opacity: 0;
  }
  15%, 85% {
    bottom: 60px;
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
`
export const activityScoreChattingAni = keyframes`
  0% {
    opacity: 0;
    width: 42px;
    height: 42px;
  }
  1%, 3% {
    opacity: 1;
    width: 42px;
    height: 42px;
    animation-timing-function: cubic-bezier(.99,0,1,1);
  }
  7%, 87% {
    opacity: 1;
    width: 100%;
  }
  90% {
    opacity: 1;
    width: 42px;
    height: 42px;
  }
  100% {
    opacity: 0;
    display: none;
  }
`
export const ActivityScorePopup = styled.div`
  position: fixed;
  bottom: 60px;
  left: 50%;
  z-index: -1;
  transform: translate3d(-50%, 0, 1px);
  opacity: 0;
  &.active {
    z-index: 10010;
    animation: ${activityScoreAni} 4s 1s 1 forwards;
    &.achieved {
      animation-duration: 5s;
    }
  }
  &.continuous-acq {
    height: auto;
    min-height: calc(64px * 2 + 15px);
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    max-width: 312px;
    .activity-score-notice-popup {
      position: relative;
      margin-top: 15px;
    }
  }
  &.chatting { // 채팅창(모바일)
    width: auto;
    height: 100%;
    position: static;
    transform: translate3d(0, 0, 1px);
    opacity: 1;
    animation-name: none;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    flex-flow: column;
    &.active {
      .activity-score-notice-popup {
        &.chatting {
          opacity: 0;
          margin-left: auto;
          animation: ${activityScoreChattingAni} 4s 1s 1 forwards;
        }
        &.achieved {
          animation-duration: 6s;
        }
      }
    }
    &.continuous-acq {
      min-height: calc(42px * 2 + 5px);
      align-items: flex-start;
      .activity-score-notice-popup {
        margin: 0 0 5px 0;
      }
    }
  }
`

export const ActivityScoreNoticeWrap = styled.div`
  width: 312px;
  height: 64px;
  background: #3763DB;
  border-radius: 50px;
  box-shadow: inset 1px 1px 0 #DCE5FF33, 0 2px 6px ${props => props.theme.color.mainBg};
  padding: 0 15px 0 9px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .activity-score {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${props => props.theme.color.white};
    color: ${props => props.theme.color.modalTxt};
    text-align: center;
    line-height: 50px;
    font-weight: ${props => props.theme.fontW.bold};
    font-size: ${props => props.theme.font.large};
    margin-right: 8px;
  }
  .contents {
    width: calc(100% - 133px);
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    .title {
      color: ${props => props.theme.color.white};
      font-weight: ${props => props.theme.fontW.bold};
      font-size: ${props => props.theme.font.large};
      transform: translateY(4px);
      display: flex;
      align-items: center;
      white-space: nowrap;
      .daily-limit {
        font-size: ${props => props.theme.font.medium};
        margin-left: 3px;
      }
    }
    .user-activity-score {
      color: #EEEEEE90;
      font-weight: ${props => props.theme.fontW.regular};
      font-size: ${props => props.theme.font.medium};
      transform: translateY(-4px);
      .total-activity-score {
        display: inline-block;
        margin-top: 5px;
        color: ${props => props.theme.color.handicap};
        font-weight: ${props => props.theme.fontW.bold};
      }
    }
    &.distance {
      .title {
        transform: translateY(0px);
      }
      .user-activity-score {
        transform: translateY(0px);
      }
    }
  }
  .show-activity-score-button {
    width: 84px !important;
    min-width: 75px;
    height: 35px;
    background: #133CAE;
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.bold};
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 2px;
    #icon_gmoney {
      width: 14px;
      height: auto;
      margin: 0 3px 2px 0;
    }
  }
  .activity-score-character {
    width: 87px;
    height: auto;
    position: absolute;
    top: -65px;
    right: 7px;
    z-index: -1;
  }
  .activity-score-character-hands {
    width: 87px;
    height: auto;
    position: absolute;
    right: 7px;
    top: -12px;
  }
  // 활동점수 팝업 모바일 채팅창 스타일
  &.chatting {
    width: 42px;
    min-width: 42px;
    max-width: 240px;
    height: 42px;
    padding: 1px 7px 0 5px;
    box-shadow: inset 1px 1px 0 #DCE5FF33, 0 2px 6px #1C202B66;
    .activity-score {
      min-width: 32px;
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: ${props => props.theme.font.small};
    }
    .contents-wrap {
      width: auto;
      max-width: 100%;
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      .contents {
        width: 100%;
        margin-right: 9px;
        .title {
          font-size: ${props => props.theme.font.medium};
          height: 10px;
          line-height: ${props => props.theme.font.medium};
          transform: translateY(2px);
          white-space: nowrap;
          .daily-limit { 
            font-size: ${props => props.theme.font.small};
          }
        }
        .user-activity-score {
          font-size: ${props => props.theme.font.small};
          line-height: ${props => props.theme.font.small};
          margin-top: 0;
          .total-activity-score {
            font-size: ${props => props.theme.font.small};
          }
        }
      }
      .show-activity-score-button {
        width: 54px !important;
        min-width: 54px;
        height: 27px;
        font-size: ${props => props.theme.font.tiny};
        margin-left: -7px;
        line-height: 25px;
        #icon_gmoney {
          width: 11px;
          margin: 0 2px 1px 0;
        }
      }
    }
    .activity-score-character, .activity-score-character-hands {
      display: none;
    }
  }
`
